import React from 'react';
import { injectIntl } from 'react-intl';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, Grid, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { tracking } from '../../utils/tracking';
import { withRouter } from 'react-router-dom';
import SurveyButton, { surveyConfig } from '../SurveyButton';
import { connect } from 'react-redux';
import { getIsChubbUser } from '../../utils/user';
import { Fragment } from 'react';

const useStyles = makeStyles()(() => ({
  dialogPaper: {
    borderRadius: 16
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  dialogContent: {
    padding: '16px 32px 32px 32px',
    height: '100%'
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  sectionTitle: {
    fontSize: 28,
    marginLeft: 8,
    marginBottom: 16,
    color: 'black'
  },
  inquiryItem: {
    marginTop: 36,
    marginBottom: 36
  },
  checkIcon: {
    color: '#16BD6A',
    marginRight: 8,
    fontSize: 20
  },
  inquiryText: {
    fontSize: 16,
    color: 'black'
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center'
  },
  hotlineBox: {
    border: '1px solid #DCDFE6',
    borderRadius: 16,
    flex: 1,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  qrCodeSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16
  },
  qrCodeImage: {
    width: 160,
    height: 160
  },
  qrCodeLabel: {
    background: '#F7F7F8',
    borderRadius: 8,
    marginTop: 16,
    padding: 4,
    width: 200,
    color: 'black',
    fontWeight: 500
  },
  whatsappRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 8
  },
  whatsappIcon: {
    fontSize: 18,
    marginRight: 8
  }
}));

const SupportDialog = ({ intl, open, onClose, openChatBot, history, userDetails }) => {
  const theme = useTheme();
  const { classes } = useStyles();

  const closeAndOpenChatBot = () => {
    onClose();
    openChatBot();
  };
  const isChubbUser = getIsChubbUser();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: { classes: { root: classes.dialogPaper } }
      }}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="h6">{intl.formatMessage({ id: 'contact-support-team' })}</Typography>
        <IconButton onClick={onClose} size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Box style={{ height: '100%' }}>
          <Grid
            container
            spacing={4}
            style={{ height: '100%' }}
            sx={{
              alignItems: 'stretch'
            }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className={classes.leftColumn}>
              {!isChubbUser && (
                <Fragment>
                  <Box
                    onClick={() => {
                      history.push('/reservation');
                      tracking('Click on Support Bottom Sheet- SupportFab', {
                        Label: intl.formatMessage({ id: 'schedule-one-on-on-consultation' }),
                        Target: '/reservation'
                      });
                    }}
                    style={{
                      borderRadius: 16,
                      padding: 16,
                      background: theme.palette.primary.main,
                      cursor: 'pointer'
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    {/* <img alt="A.I. Pro" src="img/icons/ai_bg_free.svg" width={28} height={28} /> */}
                    <WhatsAppIcon style={{ color: 'white', marginRight: 8, fontSize: 24 }} />
                    <Typography
                      style={{
                        fontSize: intl.locale === 'en' ? 17 : 20,
                        fontWeight: 500,
                        color: 'white',
                        marginLeft: 8
                      }}
                    >
                      {/* {intl.formatMessage({ id: 'business-idea-chatbot' })} */}
                      {intl.formatMessage({ id: 'schedule-one-on-on-consultation' })}
                    </Typography>
                  </Box>

                  <Box
                    style={{ marginTop: 12 }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <Typography style={{ fontSize: 24, fontWeight: 600 }}>
                      {' '}
                      {intl.formatMessage({ id: '-or-' })}{' '}
                    </Typography>
                  </Box>
                </Fragment>
              )}

              <Box>
                <Box
                  onClick={closeAndOpenChatBot}
                  style={{
                    borderRadius: 16,
                    marginTop: 12,
                    marginBottom: 12,
                    padding: 16,
                    border: '1px solid black',
                    cursor: 'pointer'
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <img alt="A.I. Pro" src="img/icons/ai_bg_free.svg" width={24} height={24} />
                  <Typography style={{ marginLeft: 8, fontSize: 16, fontWeight: 500 }}>
                    {intl.formatMessage({ id: 'business-idea-chatbot' })}
                  </Typography>
                </Box>
                {['whatsapp-support', 'book-morning-sharing-session'].map(item => (
                  <Box
                    key={item}
                    onClick={() => {
                      window.open(
                        `https://api.whatsapp.com/send?phone=85266370320&text=(WEB) ${encodeURIComponent(
                          intl.formatMessage({ id: item }) + '\n'
                        )}`,
                        '_blank'
                      );
                      // history.push('/reservation');
                      tracking('Click on Support Bottom Sheet- SupportFab', {
                        Label: intl.formatMessage({ id: item }),
                        Target: `https://api.whatsapp.com/send?phone=85266370320&text=(WEB) ${encodeURIComponent(
                          intl.formatMessage({ id: item }) + '\n'
                        )}`
                      });
                    }}
                    style={{
                      borderRadius: 16,
                      marginTop: 12,
                      marginBottom: 12,
                      padding: 16,
                      border: '1px solid black',
                      cursor: 'pointer'
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <WhatsAppIcon color="primary" style={{ marginRight: 8, fontSize: 24 }} />
                    <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                      {intl.formatMessage({ id: item })}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className={classes.rightColumn}>
              <Box className={classes.hotlineBox}>
                <Typography style={{ fontSize: intl.locale === 'en' ? 15 : 18, fontWeight: 500, color: 'black' }}>
                  {intl.formatMessage({ id: 'portfoplus-support-hotline' })}
                </Typography>
                <Box className={classes.whatsappRow}>
                  <WhatsAppIcon color="primary" className={classes.whatsappIcon} />
                  <Typography>+852 6637 0320</Typography>
                </Box>
                <Box className={classes.qrCodeSection}>
                  <img
                    src="img/whatsapp_qr_code.png"
                    alt="WhatsApp QR Code"
                    className={classes.qrCodeImage}
                    width={160}
                    height={160}
                  />
                  <Typography className={classes.qrCodeLabel}>
                    {intl.formatMessage({ id: 'scan-whatsapp-to-contact' })}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid size={12} style={{ textAlign: 'center' }}>
              <SurveyButton data={{ email: userDetails.email }} config={surveyConfig} />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const container = connect(state => ({
  userDetails: state.user.userDetails
}))(SupportDialog);

export default injectIntl(withRouter(container));
